import { useNavigate } from "react-router-dom";

/**
 * Helper function to display value or "-" if not present
 * @param {any} value - The value to display
 * @param {string} [suffix] - Optional suffix (e.g., "%")
 * @returns {string} - The formatted value or "-"
 */
const displayValue = (value, suffix = "") => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  return `${value}${suffix}`;
};

const SchoolTableRow = ({ school, disabled }) => {
  const navigate = useNavigate();

  return (
    <tr
      key={school.school_id}
      style={{
        cursor: "pointer",
      }}
      onClick={() => navigate(`/organization/school/${school.school_id}`)}
    >
      <td className="custom-id">{displayValue(school?.school_name)}</td>
      <td>{displayValue(school?.students)}</td>
      <td>{displayValue(school?.avg_completion, "%")}</td>
      <td>{displayValue(school?.avg_quiz_score, "%")}</td>
      <td>{displayValue(school?.pass_rate, "%")}</td>
      <td>{displayValue(school?.avg_attempts)}</td>
      <td>
        <button
          className="action-view-btn"
          disabled={disabled}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            navigate(`/organization/school/${school.school_id}`);
          }}
          style={{
            backgroundColor: "transparent",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <i className="bi bi-eye" style={{ color: "#6c757d" }}></i>
        </button>
      </td>
    </tr>
  );
};

export default SchoolTableRow;
